if (!window.crypto) {
    (window as any).crypto = (window as any).msCrypto;
}

export {};